import React from 'react'
import StepInfo from '../../StepInfo'
import { FormattedMessage } from 'react-intl'
import StepGuideNumbers from '../../StepGuideNumbers';
import useMediaQuery from 'utils/hooks/useMediaQuery';
import Step1Form from './components/Step1Form';
import StepInfoContainer from '../../StepInfo/container';
import "./styles/Step1.scss";

const Step1 = () => {
  const isMobile = useMediaQuery("(max-width: 1199px)");
  const progressStepValue = 33;
  const currentSteps = [0, 1];

  return (
    <main className="step0--main">
      <StepInfoContainer
        subtitle={
          <FormattedMessage
            id="ProjectStepForm.step0.subtitle"
            defaultMessage="¡Bienvenido al sistema de la Biblioteca de Proyectos!"
          />
        }
        additionalInfo={
          <FormattedMessage
            id="ProjectStepForm.step0.additionalInfo"
            defaultMessage="Diligenciando el siguiente formulario, podrás cargar el tuyo."
          />
        }
        description={
          <FormattedMessage
            id="ProjectStepForm.step0.description"
            defaultMessage="El proyecto estará sujeto a aprobación del área de Mercadeo del negocio y de Mercadeo Central."
          />
        }
      />
      {isMobile && (
        <StepGuideNumbers
          currentStep={currentSteps}
          progressStepValue={progressStepValue}
          isMobile={isMobile}
        />
      )}
      <section className="step0--main__wizard-form">
        {!isMobile && <StepGuideNumbers currentStep={currentSteps} />}
        <div className="main__wizard-container border bg-light col-12 col-lg-8 p-4 px-lg-5">
          <progress max={100} value={progressStepValue} className="w-100" />
          <h5 className="step0--main__form-title mt-4 font-weight-bold">
            <FormattedMessage
              id="ProjectStepForm.step1.title"
              defaultMessage="Información general del proyecto"
            />
          </h5>
          <hr />
          <p className="step0--main__form-description font-weight-bold">
            <FormattedMessage
              id="ProjectStepForm.step1.description"
              description="Step 1 form description"
              defaultMessage="A continuación, debes diligenciar todos los datos del proyecto"
            />
          </p>
          <Step1Form />
        </div>
      </section>
    </main>
  );
}

export default Step1;